import type { SavedAttachmentInfo } from "@/entities/attachments/types";

export enum WorkflowScoreStatus {
  NO_SCORE = 1,
  IN_PROGRESS = 2,
  REQUIRED_COMPLETED = 3,
  COMPLETED = 4
}

export interface CheckboxWithTextValue {
  checked: boolean;
  text: string;
}

export interface DateRangeValue {
  fromDate: string;
  toDate: string;
}

export type OnboardingWorkflowResponseValue =
  | string
  | number
  | string[]
  | SavedAttachmentInfo[]
  | DateRangeValue
  | CheckboxWithTextValue
  | boolean
  | undefined;
